import { render, staticRenderFns } from "./ActiveFilterList.vue?vue&type=template&id=b8cc3f90&"
import script from "./ActiveFilterList.vue?vue&type=script&lang=js&"
export * from "./ActiveFilterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports